import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@fiverr-private/fit';
import PopUp from '../ModalThemePopUp';
import * as Translations from '../../providers/i18n';
import './style.scss';

class AddYourNamePopUp extends React.Component {
    constructor(props){
        super(props);

        this.state ={
            firstNameInput:'',
            lastNameInput:''
        };

        this.firstNameInputHandelr = this.firstNameInputHandelr.bind(this);
        this.lastNameInputHandelr = this.lastNameInputHandelr.bind(this);
        this.updateClick = this.updateClick.bind(this);
    }

    firstNameInputHandelr(e) {
        this.setState({
            firstNameInput: e.target.value
        });
    }

    lastNameInputHandelr(e) {
        this.setState({
            lastNameInput: e.target.value
        });
    }

    updateClick() {
        const { onUpdateClick } = this.props;
        const { firstNameInput, lastNameInput } = this.state;

        onUpdateClick(firstNameInput, lastNameInput);
    }

    render() {
        const {
            firstNameInput,
            lastNameInput
        } = this.state;

        const {
            onExitWithoutFullName,
            i18n
        } = this.props;

        const shouldDisableButton = !(firstNameInput && lastNameInput);

        return (
            <PopUp name="add-your-name-modal attachments_preview-package order_page_perseus"
                autoOpen={true}
                buttonText={i18n.t('attachments_preview.add_your_name.update')}
                onClickFooterButton={this.updateClick}
                onClickCloseButton={onExitWithoutFullName}
                isButtonDisabled={shouldDisableButton}
                header={i18n.t('attachments_preview.add_your_name.header')}>
                {() => (
                    <div>
                        <p className="font-accent modal-text">{i18n.t('attachments_preview.add_your_name.text')}</p>
                        <div className="name-container">
                            <h3 className="font-accent">{i18n.t('attachments_preview.add_your_name.first_name')}</h3>
                            <Input className="name-input" value={firstNameInput} onChange={this.firstNameInputHandelr}/>
                        </div>
                        <div className="name-container">
                            <h3 className="font-accent">{i18n.t('attachments_preview.add_your_name.last_name')}</h3>
                            <Input className="name-input" value={lastNameInput} onChange={this.lastNameInputHandelr}/>
                        </div>
                    </div>
                )}
            </PopUp>
        );
    }
}

AddYourNamePopUp.propTypes = {
    onUpdateClick: PropTypes.func,
    onExitWithoutFullName: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(AddYourNamePopUp);
